// Multivariate Dependencies
import React, { forwardRef } from 'react';
// Components
import { Icon } from '../../Icon';
export var IconButtonStructure = forwardRef(function (_a, ref) {
    var className = _a.className, ariaLabel = _a.ariaLabel, icon = _a.icon, disabled = _a.disabled, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    return (React.createElement("button", { ref: ref, className: className, disabled: disabled, type: 'button', onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement(Icon, { name: icon, ariaLabel: ariaLabel })));
});
//# sourceMappingURL=IconButtonStructure.js.map